module.exports = __webpack_public_path__ + "img/newLogo1.0b5a8bc9.png";